import BaseApi from './BaseApi';

export type S3Url = {
  s3Key: string;
  url: string;
};

/**
 * 画像取得API。
 */
class GetChatImageApi extends BaseApi {
  async get(channelId: string, ...keys: string[]) {
    return await this.execute('getChatImageApi', {
      method: 'POST',
      body: { channelId: channelId, s3Key: keys }
    }).then(({ result }) => result.urlList as S3Url[]);
  }
}

export default GetChatImageApi;
